<template lang="pug">
  article.article-item
    .jumbo
      .mask
        img(:src="img" :alt="title", :style="`object-position: ${alignment}`")
    .wrap
      header
        h2.title
          small(v-if="beforetitle") {{beforetitle}}
          span(v-html="title")
          small(v-if="aftertitle") {{aftertitle}}
        h4.under(v-if="undertitle") {{undertitle}}
        span.more(v-if="more") ver más

</template>
<script>
export default {
  props: {
    title: String,
    undertitle: String,
    beforetitle: String,
    aftertitle: String,
    img: String,
    more: Boolean,
    hovered: Boolean,
    alignment: String
  },
  computed: {
    brTitle(){
      const ttext = this.title.trim();
      return ttext.replace(' ', '<br>')
    },
  }
}
</script>
<style lang="scss" scoped>







  .archive-item{
    &:hover{
      span.more{
        &:after{
          padding-left: 1rem;
        }
      }
      .mask{
        img{
          opacity: 1;
          transform: scale(1.008);
        }
      }
    }
  }

</style>